import types from "../actionTypes";

const INITIAL_STATE = {
    isFetchingParkingActive: false,
    parkingActive: [],
    errors: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case types.PARKING_ACTIVE_FETCH_SUCCESS:
            return {
                ...state,
                isFetchingParkingActive: false,
                parkingActive: action.payload.parkingActive,
            };
        case types.PARKING_ACTIVE_FETCH_FAIL:
            return {
                ...state,
                isFetchingParkingActive: false,
                errors: action.payload.error,
            };
        case types.PARKING_ACTIVE_FETCH_REQUEST:
            return {
                ...state,
                isFetchingParkingActive: true,
            };

        default:
            return state;
    }
};
